import { InputLabel } from "@mui/material";
import "./MUIInputLabel.style.css";

const MUIInputLabel = ({ children, style, isLight }) => {
  return (
    <InputLabel
      style={{marginBottom: '4px', ...style}}
      className={isLight ? "mui-input-label" : "mui-input-label-dark"}
    >
      {children}
    </InputLabel>
  );
};

export default MUIInputLabel;
